module.exports = __webpack_public_path__ + "public/img/Editing Video di Capcut untuk Content Creator.8260b5b6.png";